<template>
  <div>
    <collapsibleItem>
      <div slot="heading">波浪设置</div>
      <div slot="body">
        <template v-for="(color, index) in liquidFillColorList">
          <chart-color-setting
            class="mt8"
            title="颜色设置"
            lineDirection="y"
            :color.sync="liquidFillColorList[index]"
          />
        </template>
        <div class="mt16">
          <span class="fs14">背景颜色</span>
          <color-picker :color.sync="bgColor" />
        </div>
        <!-- 文本设置 -->
        <div class="mt16">
          <div>
            <cx-check-box :value.sync="showLabel">数值设置</cx-check-box>
            <div class="mt16" v-if="showLabel">
              <text-setting-update
                :fontColor.sync="labelFontColor"
                :fontFamily.sync="labelFontFamily"
                :fontSize.sync="labelFontSize"
                :fontWeight.sync="labelFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
          <div class="mt16" v-if="showLabel">
            <cx-check-box :value.sync="showDataName">显示名称</cx-check-box>
            <div
              class="mt16"
              v-if="showDataName && (checkType(labelNameValueFontWeight) || checkType(labelNameValueFontColor))"
            >
              <text-setting-update
                class="mb16"
                :fontColor.sync="labelNameValueFontColor"
                :fontFamily.sync="labelNameValueFontFamily"
                :fontSize.sync="labelNameValueFontSize"
                :fontWeight.sync="labelNameValueFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
          <div class="mt16" v-if="showLabel">
            <cx-check-box v-if="!getValueIsPercentage" :value.sync="showLabelUnit">显示单位</cx-check-box>
            <span v-else>显示单位</span>
            <div class="mt16" v-if="showLabelUnit">
              <span class="font14 mr10 half-label">显示文本</span>
              <el-input
                class="width-half-bigWidth el-input el-input--suffix"
                placeholder="请输入"
                :readonly="getValueIsPercentage"
                v-model="showLabelUnitValue"
              >
              </el-input>
            </div>
            <!-- 字体和颜色 -->
            <!--字重和字号 -->
            <div
              class="mt16"
              v-if="showLabelUnit && (checkType(labelUnitValueFontWeight) || checkType(labelUnitValueFontColor))"
            >
              <text-setting-update
                class="mb16"
                :fontColor.sync="labelUnitValueFontColor"
                :fontFamily.sync="labelUnitValueFontFamily"
                :fontSize.sync="labelUnitValueFontSize"
                :fontWeight.sync="labelUnitValueFontWeight"
                colorMode="chart"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">中心点位置</div>
      <div slot="body">
        <div class="mb16" v-if="checkType(position1)">
          <div class="font14 list-label">距离左边框</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="position1"
              :step="1"
              :min="0"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="position1"
                inputSuffixs="%"
                placeholder="请输入"
                :max="100"
                :step="1"
                :min="0"
              />
<!--              <el-input-->
<!--                class="percent100"-->
<!--                v-model="position1"-->
<!--                placeholder="请输入"-->
<!--                :controls="false"-->
<!--                :min="0"-->
<!--                :step="1"-->
<!--                :max="100"-->
<!--                type="number"-->
<!--                v-inputHandle="{ this1, type: 'position1' }"-->
<!--              >-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">%</span>-->
<!--                </template>-->
<!--              </el-input>-->
            </div>
          </div>
        </div>
        <div class="mb16" v-if="checkType(position2)">
          <div class="font14 list-label">距离上边框</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="position2"
              :step="1"
              :min="0"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="position2"
                inputSuffixs="%"
                placeholder="请输入"
                :max="100"
                :min="0"
                :step="1"
              />
<!--              <el-input-->
<!--                class="percent100"-->
<!--                v-model="position2"-->
<!--                placeholder="请输入"-->
<!--                :controls="false"-->
<!--                :min="0"-->
<!--                :step="1"-->
<!--                :max="100"-->
<!--                type="number"-->
<!--                v-inputHandle="{ this1, type: 'position2' }"-->
<!--              >-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">%</span>-->
<!--                </template>-->
<!--              </el-input>-->
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"
export default {
  mixins: [publicData],

  props: {
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    },
    getValueIsPercentage: {
      type: Boolean,
      required: true
    },
    showLabelName: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      this1: this,
      liquidFillColorList: [],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      labelTypeList: [
        {
          title: "数据标题",
          value: "{b}"
        },
        {
          title: "百分比",
          value: "{d}%"
        },
        {
          title: "数据标题+百分比",
          value: "{b}:{d}%"
        },
        {
          title: "数值+百分比",
          value: "{c}:{d}%"
        },
        {
          title: "数据标题+数值",
          value: "{b}:{c}"
        }
      ],
      labelStyleList: [
        {
          title: "饼图",
          value: ""
        },
        {
          title: "玫瑰图",
          value: "radius"
        }
      ],
      labelSelectOptions: [
        {
          label: "样式1",
          value: 1
        },
        {
          label: "样式2",
          value: 2
        }
      ]
    }
  },
  created() {
    this.init()
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    liquidFillColorList: {
      deep: true,
      handler(val, oldVal) {
        if (val.length == 0) return
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        val.forEach((item, index) => {
          params.data[index].itemStyle.color = item
        })
        this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
      }
    }
  },
  computed: {
    showDataName: {
      get() {
        return this.showLabelName
      },
      set(newVal) {
        this.$emit("update:showLabelName", newVal)
      }
    },
    bgColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "backgroundStyle.color", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".backgroundStyle.color", false)
      }
    },
    radius1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.0", "radius1", "30%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.0", false)
      }
    },
    radius2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.1", "radius2", "55%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.1", false)
      }
    },
    position1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "center.0", "position1", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".center.0", false)
      }
    },
    position2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "center.1", "position2", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".center.1", false)
      }
    },
    // 显示标签文字
    showLabel: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.show", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.show", false)
      }
    },
    labelFormatter: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.formatter")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.formatter", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontFamily")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontFamily", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.color", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontWeight", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontSize", false)
      }
    },
    labelSelectData: {
      get() {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        return pluginName.indexOf("labelFormaterStringToFuncPlugin") > -1 ? 2 : 1
      },
      set(val) {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        if (val === 1) {
          //样式1不要插件
          let index = pluginName.indexOf("labelFormaterStringToFuncPlugin")
          pluginName.splice(index, 1)
          this.options.chartOption.series.forEach((item, index) => {
            this.$changeOptionsEV(null, "chartOption.series." + index + ".labelLayout", false)
          })
        } else if (val === 2) {
          //样式2带插件
          pluginName.push("labelFormaterStringToFuncPlugin")
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },
    labelColorType: {
      get() {
        return this.labelLineColor ? "custom" : "default"
      },
      set(val) {
        if (val === "default") {
          this.labelLineColor = null
        } else if (val === "custom") {
          this.labelLineColor = "#fff"
        }
      }
    },
    showLabelUnitValue: {
      get() {
        if (this.getValueIsPercentage) {
          return "%"
        }else if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return this.seriesSettingItem.unit
        }  else if (typeof this.seriesSettingItem.label.formatter === "string") {
          this.checkFormatterValue()
          let formatter = this.seriesSettingItem.label.formatter
          const start = formatter.indexOf("valueUnit|") + 10
          let str = formatter.substring(start, formatter.length)
          const end = str.indexOf("}")
          return str.substr(0, end)
        } else {
          return ""
        }
      },
      set(newVal) {
        let name = this.showLabelName ? "\n{b|{b}}" : ""
        let formatter = this.seriesSettingItem.label.formatter
        if(typeof formatter !== "function"){
          const start = formatter.indexOf("valueUnit|") + 10
          let newFormatter = formatter.substr(0, start) + newVal + "}" + name
          this.$changeOptionsEV(newFormatter, "chartOption.series." + this.index + ".label.formatter", false)
        }
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".unit", false)
      }
    },
    showLabelUnit: {
      get() {
        if (this.getValueIsPercentage) {
          return true
        } else if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return !!this.seriesSettingItem.unit
        } else if (this.seriesSettingItem.label.formatter) {
          this.checkFormatterValue()
          let formatter = this.seriesSettingItem.label.formatter
          const start = formatter.indexOf("valueUnit|") + 10
          let str = formatter.substring(start, formatter.length)
          const end = str.indexOf("}")
          return str.substr(0, end).length > 0 ? true : false
        } else {
          return false
        }
      },
      set(newVal) {
        let name = this.showLabelName ? "\n{b|{b}}" : ""

        let formatter = this.seriesSettingItem.label.formatter
        if(typeof formatter !== "function"){
          const start = formatter.indexOf("valueUnit|") + 10
          let unit = newVal ? "单位" : ""
          let newFormatter = formatter.substr(0, start) + unit + "}" + name
          this.$changeOptionsEV(newFormatter, "chartOption.series." + this.index + ".label.formatter", false)
        }
        if (!newVal) {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV("", "chartOption.series." + this.index + ".unit", false)
          }
        } else {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV(" ", "chartOption.series." + this.index + ".unit", false)
          }
        }
      }
    },
    labelUnitValueFontFamily: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontFamily", false)
      }
    },
    labelUnitValueFontSize: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontSize", false)
      }
    },
    labelUnitValueFontWeight: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontWeight", false)
      }
    },
    labelUnitValueFontColor: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.color", false)
      }
    },
    labelNameValueFontFamily: {
      get() {
        return this.seriesSettingItem.label.rich.b.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.b.fontFamily", false)
      }
    },
    labelNameValueFontSize: {
      get() {
        return this.seriesSettingItem.label.rich.b.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.b.fontSize", false)
      }
    },
    labelNameValueFontWeight: {
      get() {
        return this.seriesSettingItem.label.rich.b.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.b.fontWeight", false)
      }
    },
    labelNameValueFontColor: {
      get() {
        return this.seriesSettingItem.label.rich.b.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.b.color", false)
      }
    },
    labelType: {
      get() {
        // console.log();
        // return this.hasProperty(this.seriesSettingItem, "type")
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "roseType", "radius")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".roseType", false)
      }
    }
  },
  methods: {
    init() {
      this.initLiquidFillColorList()
    },
    // 初始化pieColorType
    initLiquidFillColorList() {
      let result = []
      this.seriesSettingItem.data.forEach(item => {
        if (item.itemStyle.color) {
          result.push(item.itemStyle.color)
        } else {
          result.push(this.seriesSettingItem.itemStyle.color)
        }
      })
      this.liquidFillColorList = result
    },
    checkFormatterValue() {
      if (!this.seriesSettingItem.label.formatter) {
        this.$changeOptionsEV("{c}{valueUnit| }", "chartOption.series." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series." + this.index + ".label.rich",
          false
        )
      }
    },
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.pie-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
</style>
